import { API } from '../../../apis/limeAuthUtils/apiWrapper';

export async function createAsset(body) {
    /**
     * function to create asset with customized settings
     * body: body
     */
    const apiName = 'v1/asset-management';
    const myInit = {
        body: body,
    };
    return await API.put(apiName, '/v1/assets', myInit);
}
